import {
    FEED_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    FEED_CLEAR_FILTER_CRITERIA as CLEAR_FILTER_CRITERIA,
    FEED_MODERATE,
    FEED_TOGGLE_REJECTION_REASON_MODAL,
    FEED_KNOWLEDGE_ITEM_REQUEST as ITEM_REQUEST,
    FEED_KNOWLEDGE_ITEM_RESPONSE as ITEM_RESPONSE,
    FEED_KNOWLEDGE_LIST_PAGE_REQUEST as LIST_PAGE_REQUEST,
    MODERATION_FEED_LIST_REQUEST as LIST_REQUEST,
    FEED_KNOWLEDGE_LIST_RESPONSE as LIST_RESPONSE,
    FEED_KNOWLEDGE_LIST_SEARCH_REQUEST as LIST_SEARCH_REQUEST,
    FEED_SET_EDIT_MODE as SET_EDIT_MODE,
    FEED_SET_KNOWLEDGE_FILTER as SET_FILTER,
    FEED_UPDATE_FILTER_CRITERIA as UPDATE_FILTER_CRITERIA,
    FEED_UPDATE_IMAGE as UPDATE_IMAGE,
    FEED_UPDATE_MODEL as UPDATE_MODEL,
    FEED_KNOWLEDGE_ITEM_FULLTEXT_RESPONSE
} from "../../actions/action-types"
import {
    FeedFilterModel,
    updateFeedSearchFilterModel
} from "../../models/filters/feed-filter"
import {
    toUI as feedToUI,
    updateFeedChangeModel,
    FeedModel
} from "../../models/entities/feed"
import PresentationReducerBuilder from "./build-presentation-reducer"
import { serialiseSearchCriteria } from "../paging/paging-reducer-utils"
import { defaultSearchCriteria } from "../paging/feed-paging-reducer"

const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        UPDATE_IMAGE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE,
        CLEAR_FILTER_CRITERIA,
        UPDATE_FILTER_CRITERIA,
        SET_FILTER,
        SET_EDIT_MODE,
        ITEM_REQUEST,
        ITEM_RESPONSE,
        LIST_REQUEST,
        LIST_PAGE_REQUEST,
        LIST_SEARCH_REQUEST,
        LIST_RESPONSE
    })
    .updateChangeModel(updateFeedChangeModel)
    .workingModelToUI(feedToUI)
    .workingModelClass(FeedModel)
    .workingFilterModelClass(FeedFilterModel)
    .updateSearchFilterModel(updateFeedSearchFilterModel)
    .defaultState({
        workingModel: new FeedModel(),
        searchCriteria: serialiseSearchCriteria(defaultSearchCriteria),
        workingFilterModel: new FeedFilterModel()
    })
    .build()

export default (state = undefined, action) => {
    const defaultReduction = defaultReducer(state, action)
    const { type } = action
    switch (type) {
        case FEED_MODERATE:
            return {
                ...defaultReduction,
                isSavingItem: true
            }
        case FEED_TOGGLE_REJECTION_REASON_MODAL:
            const { isRejectReasonModalOpen } = defaultReduction
            return {
                ...defaultReduction,
                isRejectReasonModalOpen: !isRejectReasonModalOpen
            }
        case ITEM_REQUEST:
            return {
                ...defaultReduction,
                fulltext: null,
                isFetchingFulltext: true
            }
        case FEED_KNOWLEDGE_ITEM_FULLTEXT_RESPONSE:
            return {
                ...defaultReduction,
                fulltext: action.data && action.data.fulltext,
                isFetchingFulltext: false
            }
        default:
            return defaultReduction
    }
}
